import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';
import { useI18n } from 'vue-i18n';
import { useLocale } from './useLocale';
import { useJsonLd } from './useJsonLd';

/**
 * Inject BreadcrumbList JSON-LD for a public page.
 * Generates: Home > Page Title
 */
export function usePublicPageBreadcrumb(routeName: string, titleKey: string) {
    const { t, locale } = useI18n();
    const { localeDomains } = useLocale();
    const page = usePage<{ localeSlugs: Record<string, string> }>();

    function slug(name: string): string {
        return '/' + ((page.props.localeSlugs as Record<string, string>)?.[name] || name);
    }

    const homeUrl = computed(() => {
        const domains = localeDomains.value || {};
        return domains[locale.value] || 'https://novantt.com';
    });

    const pageUrl = computed(() => `${homeUrl.value}${slug(routeName)}`);

    const breadcrumbJsonLd = computed(() => JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        'itemListElement': [
            {
                '@type': 'ListItem',
                'position': 1,
                'name': 'Novantt',
                'item': homeUrl.value,
            },
            {
                '@type': 'ListItem',
                'position': 2,
                'name': t(titleKey),
                'item': pageUrl.value,
            },
        ],
    }));

    useJsonLd(breadcrumbJsonLd, 'breadcrumb');

    return { homeUrl, pageUrl };
}
